import * as React from 'react';
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import Box from '@mui/material/Box';
import Slider, { SliderThumb, SliderValueLabel, SliderMark } from '@mui/material/Slider';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';

import {getBs4Style, isNullOrNaN} from '../../Bs4Components/Bs4Utils'

import Bs4Stores from '../../Bs4Stores'
import Bs4GenericField from './Bs4GenericField'

export default class Bs4SelectSlider extends Bs4GenericField {

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value);
      if (typeof value === 'undefined') {
        value = this.bs4Store[0];
        // console.log('...Bs4SelectSlider...<><>', this.props?.field?.fieldLabel, '>',valueOrg, '<', value, this.bs4Store);
      }
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.filter(item => item.id == value)[0] || null;
      if (typeof value === 'undefined') value = null;
    }
    this.setValue(value);
  }

  getValueBs4 () {    
    return this.value?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  SelectSliderThumbComponent = (props) => {
    const theme = useTheme();
    const { children, ...other } = props;
    const { ownerState } = other;
    const option = ownerState.marks[ownerState.value]

    return (
      <Bs4Tooltip
        title={(
          <Box component='span'>
            <Typography sx={{whiteSpace: 'pre-line'}}>{option?.name}</Typography>
            <Typography sx={{whiteSpace: 'pre-line'}}>{option?.text}</Typography>
          </Box>
        )}
      >
      <SliderThumb 
        {...other}
        sx={{
          width: option?.icon ? 45 : 'auto', 
          height: 45,
          opacity: 1, 
          borderRadius: '999px',
          ...option?.bs4Style,
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: theme.shadows[5],
        }}
      >
        {children}        
        <Box className={option?.icon} sx={{fontSize: 27}}/>        
      </SliderThumb>
      </Bs4Tooltip>
    );
  }
  
  SelectSliderMarkComponent = (props) => {
    const theme = useTheme();
    const option = props.ownerState.marks[props['data-index']]

    return (
      <Bs4Tooltip
        title={(
          <Box component='span'>
            <Typography sx={{whiteSpace: 'pre-line'}}>{option?.name}</Typography>
            <Typography sx={{whiteSpace: 'pre-line'}}>{option?.text}</Typography>
          </Box>
        )}
      >
      <SliderMark 
        {...props}         
        sx={{          
          width: option?.icon ? 25 : 'auto',           
          height: 25,
          opacity: 1, 
          borderRadius: '999px',
          border: 'none',
          //borderWidth: props.markActive ? 3 : 2,
          //borderColor: props.markActive ? theme.palette.primary.main : lighten(theme.palette.primary.main, 0.622),
          transform: 'translate(-50%, -50%)',
          ...option?.bs4Style,
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: props.markActive ? theme.shadows[6] : theme.shadows[1],
        }}>
        <Box className={option?.icon}/>
      </SliderMark>
      </Bs4Tooltip>
    );
  }

  ValueLabelComponent = (props) => {
    const { children, open, value, ownerState } = props;

    const option = ownerState.marks[ownerState.value];
    const text = option?.text || option?.name 

    // console.log('... Select thumb ...', ownerState.value, value)
    
    return (
      <Bs4Tooltip 
        open={open} 
        enterTouchDelay={0} 
        placement="top" 
        title={<Typography sx={{whiteSpace: 'normal', whiteSpace: 'pre-line'}}>{text}</Typography>}>
        {children}
      </Bs4Tooltip>
    );
  }

  getValueFromBs4Store = (value, bs4store) => {
    const index = bs4store.findIndex(option => String(option?.id) === String(value?.id));
    if (index < 0) return null;
    return index;
  }
  
  getBs4Store = (bs4Store, theme) => {
    return bs4Store.map((option, index) => {        
      option.bs4Style = getBs4Style(option.style, {});
      if (!option.bs4Style.backgroundColor) option.bs4Style.backgroundColor = theme.palette.background.default;
      if (!option.icon) option.icon = "fa-solid fa-circle";
      option.value = index;
      return option;
    })
  }

  ViewComponentField = (props) => {
    const formField = this;        
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)    
    this.refFocus = React.useRef();
    const theme = useTheme();
    const [bs4Store, setBs4Store] = React.useState(this.getBs4Store(formField.bs4Store || [], theme));    
    const [value, setValue] = React.useState(this.getValue());
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
          setValue(this.getValue());
          if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      }
      this.on(Bs4GenericField.CHANGE, CHANGE);
      
      const CHANGE_STORE = (bs4Store) => {        
        const newBs4Store = this.getBs4Store(bs4Store || [], theme);
        setBs4Store(newBs4Store);
        this.setValueBs4(this.getValueBs4());
      }
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, value, theme, setValue, setError, setBs4Store]);

    const handleChange = (event, newValue, activeThumb) => {
      const option = bs4Store[newValue];
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(option);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);      
    }

    return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        {/* <Typography sx={{whiteSpace: 'pre-line'}}>{marks[value]?.option?.name}</Typography> */}
        <Box px={2}>
          <Slider
            ref={this.refFocus}
            size="small"
            value={formField.getValueFromBs4Store(value, bs4Store)}
            onChange={handleChange}
            slots={{ 
              thumb: formField.SelectSliderThumbComponent,
              //valueLabel: formField.ValueLabelComponent,
              mark: formField.SelectSliderMarkComponent,
            }}
            step={null}
            valueLabelDisplay='off'
            marks={bs4Store}
            max={bs4Store.length - 1}
          />
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}